import { combineReducers } from 'redux';
import { Cart } from '@pegasus/cart';

import { defineFetchForNamespace } from 'src/client/components/shared/redux/fetch';
import { fetchCart } from 'src/client/api/services/cart';

export const NAME = 'fetch';
export const NAMESPACE = 'cart';

const {
    reducer,
    getIsInitial,
    getIsLoading,
    getData,
    resetData,
    fetchData,
} = defineFetchForNamespace<Cart, void, typeof NAMESPACE, typeof NAME>(NAMESPACE, NAME, () =>
    fetchCart(),
);

const getCartReducer = () => ({
    [NAMESPACE]: combineReducers({
        [NAME]: reducer,
    }),
});

export {
    getCartReducer,
    getIsInitial,
    getIsLoading,
    getData as getCart,
    fetchData as fetchCart,
    resetData as resetCart,
};
